import LogbookDietsPage from "./pages/LogbookDietsPage";
import LogbookDietDetailsPage from "./pages/LogbookDietDetailsPage";
import DietAssessorLogbooksPage from "./pages/DietAssessorLogbooksPage";

import MyAssignedDietsPage from "./pages/MyAssignedDietsPage";
import MyDietLogbooksPage from "./pages/MyDietLogbooksPage";
import AssessorLogbookDetails from "./pages/AssessorLogbookDetails";
import DietLogbookAssessmentDetailsPage from "./pages/DietLogbookAssessmentDetailsPage";
import DietApplicationAssessmentDetailsPage from "./pages/DietApplicationAssessmentDetailsPage";
export const logbookDietRoutes = [
  // Admin — gated on the privilege, see the note in chapter/routes.tsx.
  {
    path: "/application-diets",
    element: <LogbookDietsPage />,
    perms: ["application_diet.access"],
  },
  {
    path: "/application-diets/:id",
    element: <LogbookDietDetailsPage />,
    perms: ["application_diet.access"],
  },
  {
    path: "/application-diets/logbook-assessment/:id",
    element: <DietLogbookAssessmentDetailsPage />,
    perms: ["application_diet.access"],
  },
  {
    path: "/application-diets/application-assessment/:id",
    element: <DietApplicationAssessmentDetailsPage />,
    perms: ["application_diet.access"],
  },
  {
    path: "/logbook-diets/:id/assessors/:memberId/logbooks",
    element: <DietAssessorLogbooksPage />,
    perms: ["application_diet.access"],
  },

  // Assessor
  {
    path: "/assessor/logbook-diets",
    element: <MyAssignedDietsPage />,
    roles: ["assessor", "fellow", "member", "past president"],
  },
  {
    path: "/assessor/logbook/:id",
    element: <AssessorLogbookDetails />,
    roles: ["assessor", "admin", "fellow", "member", "past president"],
  },
  {
    path: "/assessor/logbook-diets/:id/logbooks",
    element: <MyDietLogbooksPage />,
    roles: ["assessor", "assessor", "fellow", "member", "past president"],
  },
];
